import { Modal } from "components";
import CardRowSegment from "components/CardRowSegment/CardRowSegment";
import FinancialRiskCard from "components/FinancialRisk/FinancialRiskCard";
import VatNumberDetails from "components/VatNumber/VatNumberDetails";
import React from "react";
import { Button } from "semantic-ui-react";
import { CompanyApi } from "queries/Company";

const displayFinancialRisk = (financialRisk: server.dto.FinancialRisk): boolean => {
  if (financialRisk == null) return false;
  if (financialRisk.comment) return true;

  const dangerousLevels: server.dto.FinancialRiskLevels[] = ["blocklist", "lowRisk", "highRisk"];
  return dangerousLevels.includes(financialRisk.level);
};

const displayVatNumber = (euVatNumber: server.dto.EuVatNumber): boolean => {
  if (euVatNumber == null || !euVatNumber.isEuMember) return false;

  return euVatNumber.viesValidationOutcome !== "valid";
};

const displayOutstandingAmounts = (amounts: server.dto.OutstandingAmount[]) => amounts.length > 0;

interface Props {
  companyId: number;
  onClose: () => void;
}
export const FinancialRiskModal = (props: Props) => {
  const companyPreviewQuery = CompanyApi.GetSidePanelData.useQuery(props.companyId, {});

  const company = companyPreviewQuery.data?.data.company;
  const outstandingAmounts = companyPreviewQuery.data?.data.outstandingAmounts ?? [];
  const financialRisk = company?.financialRisk;
  const financialRiskLevel = serverReference.financialRiskLevels.find(level => level.value === company?.financialRisk?.level) //company?.financialRisk;
  const euVatNumber = company?.euVatNumber;

  const shouldDisplayFinancialRisk = displayFinancialRisk(financialRisk);
  const shouldDisplayVatNumber = displayVatNumber(euVatNumber);
  const shouldDisplayOutstandingAmounts = displayOutstandingAmounts(outstandingAmounts);

  React.useEffect(() => {
    if (companyPreviewQuery.data == null) return;
    if (!shouldDisplayFinancialRisk && !shouldDisplayVatNumber && !shouldDisplayOutstandingAmounts) {
      props.onClose();
    }
  }, [companyPreviewQuery.data]);

  if (companyPreviewQuery.data == null) return <></>;

  if (!shouldDisplayFinancialRisk && !shouldDisplayVatNumber && !shouldDisplayOutstandingAmounts) {
    return <></>;
  }

  

  return <Modal
    title={`${RESX.GeneralWarnings.Warning}: ${company.name}`}
    handleClose={props.onClose}
    isOpen
    size="tiny"
  >
    <div className="grow1 margin-bottom">

      {shouldDisplayFinancialRisk && <div className="margin-bottom-large">
        <CardRowSegment className="margin-bottom" lineColor={financialRiskLevel?.value === "unknown" ? null : financialRiskLevel?.hexColor}>
          <FinancialRiskCard financialRisk={financialRisk} />
        </CardRowSegment>
      </div>}

      {shouldDisplayVatNumber && <div className="margin-bottom-large">
        <CardRowSegment className="margin-bottom" lineColor={euVatNumber.validationHexColor}>
          <VatNumberDetails euVatNumber={euVatNumber} companyId={company.companyId} displayDot={false} />
        </CardRowSegment>
      </div>}

      {shouldDisplayOutstandingAmounts &&
        <div className="margin-bottom-large">
          <CardRowSegment className="margin-bottom" lineColor="panel-bg-color">
            <CardRowSegment.Header>{RESX.Financial.Outstanding}</CardRowSegment.Header>
            {outstandingAmounts.map((amount, idx) => <React.Fragment key={idx}>
              {amount.total.formatted}
              <br />
            </React.Fragment>)}
          </CardRowSegment>
        </div>}
    </div>

    <div className="flex">
      <div className="grow1"></div>
      <Button primary onClick={props.onClose}>
        {RESX.Buttons.BtnOk}
      </Button>
    </div>
  </Modal >;
};

export default FinancialRiskModal;